// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import * as settingsCreators from '../../actions/settings/settingsCreators';
import { checkLoggedInUserIsGlobalAdmin } from '../../actions/authentication/authCreators';
import SettingsTabSidebar from '../../components/sidebars/SettingsTabSidebar';
import SettingsGeneralForm from './SettingsGeneralForm';
import type { Dispatch } from 'redux';

type Props = {
  routes: any,
  settings: Object,
  checkLoggedInUserIsGlobalAdmin: () => void,
  getSettings: () => void,
  updateSetting: (v: Object[]) => Promise<*>
};

type State = {
  errorMsg: string,
  successMsg: string,
  isSaving: boolean
};

export const getReturnData = (newData: Object, oldData: Object): Object[] => {
  const returnValue = [];

  Object.keys(newData).forEach(key => {
    if (newData[key] && oldData[key]) {
      if (newData[key].value !== oldData[key].value) {
        // convert boolean to string
        if (typeof newData[key].value === 'boolean') {
          newData[key].value = newData[key].value.toString();
        }
        returnValue.push(newData[key]);
      }
    }
  });

  return returnValue;
};

class SettingsGeneral extends React.Component<Props, State> {
  timeoutId: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      errorMsg: '',
      successMsg: '',
      isSaving: false
    };
    this.timeoutId = undefined;
  }

  componentWillMount() {
    this.props.checkLoggedInUserIsGlobalAdmin();
    this.props.getSettings();
  }

  handleSubmit = (values: Object) => {
    this.setState({ isSaving: true, errorMsg: '' });
    const newData = getReturnData(values, this.props.settings);
    this.props
      .updateSetting(newData)
      .then(response => this.success(response), error => this.failure(error));
  };

  success = (response: Object) => {
    if (response.status < 400) {
      this.setState({ successMsg: 'Success!', isSaving: false, errorMsg: '' });

      this.timeoutId = setTimeout(
        () => this.setState({ successMsg: '' }),
        3000
      );
    } else {
      this.failure(response);
    }
  };

  failure = (error: Object) => {
    this.setState({
      isSaving: false,
      errorMsg: error.data.message
    });
  };

  render() {
    const currentComponent = 'SettingsGeneral';
    return (
      <Grid fluid className="settings-details">
        <Helmet>
          <title>Settings - General | Campaign Targeter</title>
        </Helmet>
        <Row>
          <Col sm={12} className="generic-main-content-wrapper">
            <Row>
              <Col sm={4} lg={3} className="settings-sidebar">
                <SettingsTabSidebar activeTab={currentComponent} />
              </Col>
              <Col sm={8} lg={9} className="settings-maincontent">
                <SettingsGeneralForm
                  onSubmit={this.handleSubmit}
                  initialValues={this.props.settings}
                  enableReinitialize={true}
                  isSaving={this.state.isSaving}
                  errorMsg={this.state.errorMsg}
                  successMsg={this.state.successMsg}
                  settings={this.props.settings}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      ...settingsCreators,
      checkLoggedInUserIsGlobalAdmin
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsGeneral);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsGeneral.js